import React from 'react';
import { AppLinks, FAQLinks } from "../../../constants/app-links";

export default class ManagingPolicy {
   
    static addPet = () => {
        return (
            <div className="faqAnswer">
                <p>
                    Congratulations on a new addition to the family!
                     <br />
                    <br />
                    You can use the <a style={{fontWeight:"600"}} href={AppLinks.policy.addPet} target="_blank" rel="noopener noreferrer">Add a Pet</a> feature in the Customer Center to add your new pet to your policy.
                </p>
            </div>
        )
    }
    static breedenroll = () => {
        return (
            <div className="faqAnswer">
                <p>
                    If you have a purebred dog or cat, simply select the matching breed from the dropdown list. By beginning to type the breed, you can search the list quickly.
                    <br />
                    <br />
                    If your pet is a crossbreed (usually one purebred dog bred to another purebred dog of a different breed), we have some of the most popular combinations represented in the breed list, including Puggle, Yorkiepoo, or Goldendoodle. If the crossbreed you're looking for is not represented on the list, choose "Mixed Breed" and the weight of your pet when fully grown.
                    <br />
                    <br />
                    If your pet is a Mixed Breed (a mix of multiple breeds, or possibly you're not sure what breed your dog or cat is), you can select the predominant breed in their mix, for example, "Boxer Mix" or "Terrier Mix." If the mix is unknown or not represented on our list, select "Mixed Breed" and the weight of your pet when fully grown.
                    <br />
                    <br />
                    Your pet's medical records will be used to verify the breed selection you chose during enrollment.
                </p>
            </div>
        )
    }
    static annualDeductible = (policyFormUrl) => {
        return (
            <div className="faqAnswer">
                <p>
                  The annual deductible is by "coverage term." For example, if your policy became
                  effective on May 25, 2022, your coverage term would last through May 24, 2023.
                </p>
                <p>You can view examples of claim reimbursement calculations <a style={{fontWeight:"600"}} href={FAQLinks.claimExamples} target="_blank" rel="noopener noreferrer">here</a>.</p>
                <p>To maximize the annual deductible, we recommend that you submit all claims pertaining to accidents, illnesses and injuries.</p>
                <p>
                  <a style={{fontWeight:"600"}} href={FAQLinks.ViewPolicyDocuments} target="_blank" rel="noopener noreferrer">
                                Review your policy
                  </a>
                </p>
            </div>
        )
    }
    static afterEnroll = (policyFormUrl) => {
        return (
            <div className="faqAnswer" >
                <p>
                    Yes, you can change your policy options  <a style={{ fontWeight: "600" }} href={FAQLinks.ViewPolicyOptions} target="_blank" rel="noopener noreferrer">here</a> subject to the policy terms and conditions, or by clicking "Pet Policies" from the navigation. You can lower your deductible or raise your reimbursement level as long as you have not submitted any claims. This would result in lower out-of-pocket expenses and a higher reimbursement, and correspondingly, a higher monthly premium.
                </p>
                <p>
                    If you have submitted any claims, you will only be able to lower your reimbursement and raise your deductible. (Note: lowering your reimbursement level and/or raising your deductible are both ways to reduce the cost of your monthly premiums.)
                </p>

                <p>
                    Another way to lower the cost of your premiums is to decrease your annual limit (maximum annual payout). You can do this once per policy term, but only prior to filing any claims for that year. Once decreased, your annual limit cannot be raised again.  (<strong>Note:</strong> The annual limit you select upon enrollment is the highest annual limit your policy can have - the annual limit cannot be increased.)
                </p>
               
                <p>
                        <a style={{ fontWeight: "600" }} href={FAQLinks.ViewPolicyDocuments} target="_blank" rel="noopener noreferrer">
                  Review your policy
                  </a>
               
                </p>
            </div>

        )
    }
    static howToLowerPremiums = (policyFormUrl) => {
        return (
            <div className="faqAnswer">
                <p>
                    Subject to the policy terms and conditions, if you would like to decrease the cost of your monthly premium, you may be able to:
                    <ul className="blackdisc">
                        <li>Lower your reimbursement level</li>
                        <li>Increase your deductible</li>
                        <li>Switch from unlimited reimbursement to an annual limit or decrease the annual limit</li>
                    </ul>
                </p>
                <p>
                    The annual limit (maximum payout) you selected at enrollment can never be increased for a pet's policy, however it can be decreased at any time prior to submitting your first claim. You can do this once across the 12 months following the pet policy anniversary date - prior to submitting any claims. Once decreased, the annual limit cannot be raised again for that pet's policy. (Note: you can select different annual limits for each pet's policy.)
                </p>

                <p>
                    You can view your reimbursement, deductible and annual limit options{" "}
                    <a
                        style={{ fontWeight: "600" }}
                        href={policyFormUrl || FAQLinks.ViewPolicyOptions}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        here
                    </a>{" "}
                    or by clicking Pet Policies in the navigation.
                </p>

                <p>
                    <a
                        style={{ fontWeight: "600" }}
                        href={ FAQLinks.ViewPolicyDocuments}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Review your policy
                    </a>
                </p>
            </div>
        );
    };
}